const API_ENDPOINTS = {
  GET_ADVERTISERS: "advertiser/advertisers-summary",
  CREATE_ADVERSTISER: "/advertiser/create-advertiser",
  UPDATE_ADVERTISER_TABS: "/advertiser/update-advertiser-tabs",
  ADVERTISER_TAB_ACCESS: "/advertiser/advertiser-tab-access",
  EDIT_ADVERSTISER: "/advertiser/edit-advertiser",
  ADD_ADVERTISER_DATA: "/advertiser/add-data-configuration-details",
  ADD_CREATIVE_INSIGHTS: "/advertiser/add-creative-insights",
  EDIT_ADVERTISER_DATA: "/advertiser/edit-data-configuration-details",
  EDIT_CREATIVE_INSIGHTS: "/advertiser/edit-creative-insights",
  ADD_ADVERTISER_REPORT: "/advertiser/add-report-configuration-details",
  EDIT_ADVERTISER_REPORT: "/advertiser/edit-report-configuration-details",
  ADD_ADVERTISER_INSIGHTS: "/advertiser/add-insights-configuration-details",
  EDIT_ADVERTISER_INSIGHTS: "/advertiser/edit-insights-configuration-details",
  ACTIVE_DEACTIVE_ADVERTISER: "/advertiser/activate-deactivate-advertiser",
  // LOGIN_USER: "/user-access/login",
  SSO_GOOGLE_AUTH: "/auth/sso/google/auth",
  LOGIN_USER_DATA: "/user-access/user-details",
  LOGOUT_USER: "/user-access/logout",
  // NEW_PASSWORD: "/user-access/change-password",
  GET_AUDIENCE: "advertiser/audience",
  GET_GOOGLE_AUDIENCE: "advertiser/audience",
  GET_DECODING_TRENDS: "advertiser/trends-charts",
  GET_GOOGLE_DECODING_TRENDS: "advertiser/google-trends-charts",
  GET_DEMOGRAPHY: "advertiser/get-age-chart",
  GET_GOOGLE_DEMOGRAPHY: "advertiser/google-demography",
  GET_DECODING_CAMP_SUCCESS: "advertiser/get-decoding-campaign-success",
  GET_GOOGLE_DECODING_CAMP_SUCCESS:
    "advertiser/google-decoding-campaign-success",
  GET_EVENT_CAMP_DATA: "advertiser/event-campaign-insights",
  GET_GOOGLE_EVENT_CAMP_DATA: "advertiser/google-event-camp-comp-insights",
  GET_COMP_CREATIVE: "advertiser/comp-creative",
  GET_PLACEMENTS: "advertiser/placement-chart-data",
  GET_CREATIVE_INSIGHTS: "advertiser/creative-insight-data",
  GET_GOOGLE_CREATIVE: "advertiser/google-top-creatives",
  GET_META_AUDIT: "advertiser/meta-ads-audit",
  GET_GOOGLE_AUDIT: "advertiser/google-ads-audit",
  GET_EVENTS_LIST: "advertiser/events-list",
  GET_CAMPAIGN_ID_LIST: "advertiser/meta-campaign-id-list",
  GET_INSIGHTS_DATA: "advertiser/insights-config",
  GET_REPORT_DATA: "advertiser/report-config",
  GET_GENERATED_INSIGHTS: "advertiser/generate-insight",
  GET_RESTORE_INSIGHTS: "advertiser/default-insight",
  GET_COUNTRY_LIST: "advertiser/country_list",
  GET_METRIC_LIST: "advertiser/metrics-list",
  GET_CREATIVE_INSIGHTS_META: "advertiser/creative-insights-config",
  GET_GENERATED_COMP_INSIGHTS: "advertiser/generate-competition-insights",
  // FORGOT_PASSWORD: "advertiser/forgot-password",
  // VALIDATE_CODE: "advertiser/validate-code",
  // RESET_PASSWORD: "advertiser/reset-password",
  GET_GOOGLE_CONFIG: "advertiser/advertiser-configuration",
  GET_GOOGLE_KEYWORD: "advertiser/google-keyword",
  GET_GOOGLE_REGION: "advertiser/region-split",
  GET_GOOGLE_CAMPAIGN: "advertiser/google-campaign",
  GET_STATUS: "optimization/trends-chart",
  GET_ADSETS: "optimization/top-low-adsets",
  GET_SUMMARY: "optimization/summary-insights",
  GET_OPTI_METRIC_LIST: "optimization/metric-list",
  GET_VERTICALS: "optimization/verticals-list",
  GET_TAKEOFF_DATA: "optimization/takeoff-plan",
  GET_AUTO_LAUNCH: "optimization/auto-launch-config",
  REMOVE_LAUNCH: "optimization/remove-auto-launch",
  GET_COPILOT_RECOM: "optimization/copilot-recommendations-list",
  LAUNCH_RECOMMENDATIONS: "optimization/launch-recommendations",
  AUTO_LAUNCH: "optimization/auto-launch-config",
  REMOVE_SINGLE_LAUNCH: "optimization/remove-recommendations-launched",
  GET_RECOMMENDATIONS_DATA: "optimization/takeoff-recommendations",
  GET_COPILOT_DATA: "optimization/co-pilot-stats",
  GET_LAUNCH_SUMMARY: "optimization/launch-summery",
  GET_OPTIMISATION_CONFIG: "optimization/optimization-config",
  GET_OPT_EVENTS_LIST: "optimization/events-list",
  GET_TAKEOFF_CONVERSION_LIST: "optimization/takeoff-conversion-list",
  ADD_OPTIMISATION_CONFIG: "optimization/add-optimization-config",
  ADD_TAKE_OFF: "optimization/add-takeoff-plan",
  ADD_LAUNCH_TAKE_OFF: "optimization/launch-takeoff",
  EDIT_TAKE_OFF: "optimization/edit-takeoff-plan",
  EDIT_OPTIMISATION_CONFIG: "optimization/edit-optimization-config",
  GET_MEDIA_PLAN: "media/media-plan",
  GET_MEDIA_PLAN_REPORT: "media/media-planning-report",
  GET_CURRENCY_LIST: "media/currency-list",
  ADD_MEDIA_PLAN: "media/add-media-plan",
  EDIT_MEDIA_PLAN: "media/edit-media-plan",
  ADD_USER: "user-access/add-user",
  EDIT_USER: "user-access/edit-user",
  REJECT_USER: "user-access/reject-user",
  APPROVE_USER: "user-access/approve-user",
  GET_USERS: "user-access/users",
  DELETE_USER: "user-access/users",
  GET_ADVERTISER_DATA: "advertiser/data-config",
  GET_ANALYTICS_URL: "analytics/analytics-config",
  ADD_ANALYTICS_URL: "analytics/add-analytics-config",
  EDIT_ANALYTICS_URL: "analytics/edit-analytics-config",
  GET_ACTIVITY_LOG: "user-access/activity-logs",
  EXPORT_ACTIVITY_LOG: "user-access/export-activity-log",
  GET_MODULE_LIST: "user-access/modules",
  GET_ACTIVITY_LIST: "user-access/activities",
  ADD_ACTIVITY_LOG: "user-access/activity-log",
  VALIDATE_SHOPIFY_CRED: "feed-manager/validate/shopify",
  FEED_SHOPIFY: "feed-manager/feeds/shopify",
  VALIDATE_CSV_UPLOAD: "feed-manager/validate/csv",
  CREATE_CSV_FEED: "feed-manager/feeds/csv",
  VALIDATE_CSV_URL: "feed-manager/validate/csv-url",
  CREATE_CSV_URL_FEED: "feed-manager/feeds/csv-url",
  UPDATE_SCHEDULER: "feed-manager/feeds/",
  GET_FEED_ADV: "feed-manager/feeds/by-advertiser/",
  PAUSE_FEED: "feed-manager/feeds/",
  RESUME_FEED: "feed-manager/feeds/",
  REFRESH_FEED: "feed-manager/feeds/",
  EXPORT_FEED: "feed-manager/feeds/",
  DELETE_FEED: "feed-manager/feeds/",
  GET_TIME_ZONES: "feed-manager/timezones",
  CREATE_CHANNEL: "feed-catalog/channels",
  GET_CHANNEL_ADV: "feed-catalog/advertisers",
  CHANNEL_BY_ID: "feed-catalog/channels/",
  UPDATE_CHANNEL: "feed-catalog/channels/",
  DELETE_CHANNEL: "feed-catalog/channels/",
  GET_MAPPING_FIELDS: "feed-catalog/mapping-fields/target",
  FEED_CATALOG_CATEGORIES: "feed-catalog/categories",
  ADD_PRODUCT_STATS_CONFIG: "product-stats/add-product-stats-config",
  EDIT_PRODUCT_STATS_CONFIG: "product-stats/edit-product-stats-config",
  GET_PRODUCT_STATS_CONFIG: "product-stats/product-stats-config",
  GET_ADV_MODULE_LIST: "advertiser/modules-list",
  GET_OBJECTIVE_LIST: "advertiser/objectives",
  GET_TAKEOFF_HISTORY: "optimization/takeoff-history",
  GET_ADSET_ID: "optimization/adset-id-list",
  GET_RECOMMENDATION_HISTORY: "optimization/recommendations-history",
  GET_ONBOARDING_ADVERTISERS: "/onboarding/advertisers",
  EDIT_ONBOARDING_ADVERTISER: "/onboarding/edit-advertiser",
};

export default API_ENDPOINTS;
